// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P3Q6","footer":"styles_footer__1HOub","passCodeTooltip":"styles_passCodeTooltip__3PzxA"};